<div class="switcher" (click)="onClick($event)">
  <input type="checkbox" [checked]="checked">
  <div class="control">
    <span class="slider round" [ngStyle]="{'background-color':checked?yes.color || 'green':no.color || 'red'}" [ngClass]="{'checked':checked}"></span>
  </div>
  <span>{{checked?yes.label:no.label}}</span>
</div>